<div class="bg-blue-800 text-white text-left px-8 py-16 text-3xl rounded-b-md">
    Réunion
  </div>

  <mat-form-field appearance="legacy">
    <mat-label>Type réunion</mat-label>
    <input matInput>
  </mat-form-field>

  <mat-card>
  <div fxLayout="row" fxLayoutAlign="center center">
  <button mat-raised-button class="md-btn-add md-btn-raised-add"> <mat-icon>add</mat-icon> Ajouter</button>
  <div fxFlex="2"></div>
  <button mat-raised-button class="md-btn-search md-btn-raised-search"> <mat-icon>search</mat-icon> Rechercher</button>
  <div fxFlex="2"></div>
  <button mat-raised-button> <mat-icon>close</mat-icon> Annuler</button>
  </div>

  <mat-form-field appearance="standard">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Recherche rapide" #input>
  </mat-form-field>
  
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
  
      <!-- ID Column -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Code Type </th>
        <td mat-cell *matCellDef="let row"> {{row.code}} </td>
      </ng-container>
  
      <!-- Progress Column -->
      <ng-container matColumnDef="type_Reunion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type réunion </th>
        <td mat-cell *matCellDef="let row"> {{row.type_Reunion}} </td>
      </ng-container>
  
      <!-- Name Column -->
      <ng-container matColumnDef="period">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Périodicité </th>
        <td mat-cell *matCellDef="let row"> {{row.period}} </td>
      </ng-container>
  
      <!-- Fruit Column -->
      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Source par défaut </th>
        <td mat-cell *matCellDef="let row"> {{row.source}} </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  
      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
      </tr>
    </table>
  
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
  </div>
</mat-card>